module.exports = __webpack_public_path__ + "static/img/5.02c060a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/5.png
// module id = 4eef
// module chunks = 35